import React from "react"
import styles from "./styles.scss"
import cx from "classnames"

class WorkAtSaits extends React.Component {
  render() {
    return (
      <section
        className={cx(styles.container, {
          [styles.light]: this.props.variant === "light",
          [styles.gray]: this.props.variant === "gray",
        })}
      >
        <div className={styles.wrapper}>
          <h2>
            Att jobba på <span className={styles.primaryColor}>SAITS</span>
          </h2>
          <p className={styles.description}>
            Då och då behöver vi utöka vårt team med en ny stjärna inom
            utveckling. Det viktigaste för oss är att du är grym på det du gör,
            att våra kunders resultat alltid är i fokus och att du känner en
            stolthet i att leverera med hög precision.
          </p>
          <p>Känner du att du kan bidra till vårt team? Hör av dig till oss!</p>
        </div>
      </section>
    )
  }
}

export default WorkAtSaits



// WEBPACK FOOTER //
// ./src/components/WorkAtSaits/index.jsx